import React, { useMemo } from 'react';
import { getSourceFallback } from '../../utils/sourcecFallbacks';

interface CampaignFallbackImageProps {
  title: string;
  category?: string;
  source?: string;
  heightClassName?: string;
}

const SPECIAL_LOGO_SOURCES = new Set([
  'Federal Register - Executive Orders',
  'GovInfo - Congressional Bills',
]);

const CampaignFallbackImage: React.FC<CampaignFallbackImageProps> = ({
  title,
  category,
  source,
  heightClassName = 'h-48',
}) => {
  const displaySource = useMemo(() => {
    const value = (source || 'News').trim();
    return value.length > 0 ? value : 'News';
  }, [source]);

  const specialLogoSrc = useMemo(() => {
    if (!source || !SPECIAL_LOGO_SOURCES.has(source)) return null;
    return getSourceFallback(source);
  }, [source]);

  return (
    <div
      className={[
        'relative w-full overflow-hidden',
        heightClassName,
        'bg-[#dddddd]',
        'flex items-center justify-center',
      ].join(' ')}
      aria-label={title || displaySource}
    >
      {specialLogoSrc ? (
        <img
          src={specialLogoSrc}
          alt={displaySource}
          className="max-h-[70%] max-w-[70%] object-contain opacity-90"
          draggable={false}
        />
      ) : (
        <span className="text-[3.75rem] font-semibold leading-none text-gray-500 select-none text-center px-4">
          {displaySource}
        </span>
      )}

      {category ? (
        <div className="absolute bottom-3 left-3 z-20">
          <span className="inline-flex items-center rounded-full bg-black/60 text-white px-2.5 py-1 text-xs font-medium">
            {category}
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default CampaignFallbackImage;